import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PopupsFactory from 'components/popups/popupsFactory';
import {imageUrl} from "../../helpers/ApplicationHelper";

class Popup extends Component{
    static initPopup(props = {}) {
        PopupsFactory.initPopup(this, props);
    }

    constructor(props) {
        super(props);

        this.state = {
            hide: false
        };

        this.onpopstate = this.onpopstate.bind(this);
    }

    componentDidMount() {
        if (this.props.fixedXBtn) {
            const xNode = document.createElement('div');
            xNode.classList.add('fixed-x', `${this.props.popupClassName}-x`);
            xNode.onclick = !this.state.cantClickWithLoader && this._hide.bind(this, false);
            document.getElementById('fixed-container-layer').appendChild(xNode);
        }

        if (this.props.preventLocationBack || this.props.forcePushState) {
            history.pushState(null, '', window.location.pathname);
            window.addEventListener('popstate', this.onpopstate);
        }
        this.props.onOpen && this.props.onOpen();
    }

    componentWillUnmount() {
        this.props.onClose && this.props.onClose();
    }

    title() {
        return null;
    }

    subtitle() {
        return null;
    }

    content() {
        return null;
    }

    popupClassName() {
        if (this.props.popupClassName) {
            return this.props.popupClassName;
        } else {
            //Don't use constructor name, because it will be changed upon minification
            return '';//this.constructor.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        }
    }

    classNames() {
        if (this.props.classNames) {
            if (Array.isArray(this.props.classNames)) {
                return this.props.classNames.join(' ');
            } else {
                return this.props.classNames;
            }
        } else {
            return '';
        }
    }

    _hide(manual=true, delay=250) {
        (this.classNames.bind(this)().includes('no-animation') && (delay = 0)) || this.setState({hide: true});
        setTimeout(() => {
            if (this.props.preventLocationBack) {
                window.removeEventListener('popstate', this.onpopstate);
                !manual && history.back();
            }
            if(this.props.fixedXBtn) {
                document.getElementsByClassName(`${this.props.popupClassName}-x`)[0].remove();
            }
            PopupsFactory.destroyPopup(this.props.factoryKey);
        }, delay);

        if (this.props.onPopupClose) {
            this.props.onPopupClose.call(this);
        }
    }

    onpopstate() {
        this._hide(true);
    }

    render(){
        const subtitle = this.subtitle.bind(this)();
        return (
            <div>
                <div className={`popup ${this.popupClassName.bind(this)()} ${this.classNames.bind(this)()} ${this.state.hide ? 'hide' : ''} ${this.props.modal ? 'modal' : ''}`}>
                    {
                        this.props.displayThankYouIcon && this.title.bind(this)() !== '' ?
                            <img className="thank-you-icon" src={imageUrl("common/ThankYouIcon.svg")}
                                 alt="thank you icon"/>
                            : null
                    }
                    <h2>{this.title.bind(this)()}</h2>
                    {subtitle && <p className="subtitle">{subtitle}</p>}
                    {
                        (!this.props.fixedXBtn &&
                            <a className="x" onClick={(!this.state.cantClickWithLoader) ? this._hide.bind(this, false) : ''}>&#215;</a>) || null
                    }
                    {this.content.bind(this)()}
                </div>
                <div className={`popup-modal-shutter ${this.state.hide ? 'hide' : ''}`} onClick={(!this.state.cantClickWithLoader) ? this._hide.bind(this, false) : ''}/>
            </div>
        );
    }
}
Popup.propTypes = {
    modal: PropTypes.bool,
    single: PropTypes.bool, //is it an exclusively single popup on the screen
    popupClassName: PropTypes.string,
    classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    preventLocationBack: PropTypes.bool,
    forcePushState: PropTypes.bool
};
Popup.defaultProps = {
    modal: true,
    single: false,
    popupClassName: null,
    preventLocationBack: false,
    forcePushState: false
};

export default Popup;
